// components/About.js
import React, { useState } from 'react';
import './About.css';
import Modal from './Modal';
import imgLivingRoom6 from '../img/Living room (6).png';

function About() {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <section id="about" className="about-section">
      <div className="about-image reveal-left">
        <img src={imgLivingRoom6} alt="About the 360 Suite" />
      </div>
      <div className="about-text reveal-right">
        <h2>About this place</h2>
        <p>
          Welcome to your 360 suite! A luxury furnished 3-bedroom apartment in Abuja that offers the perfect mix of comfort and convenience with uninterrupted power from our solar backup.
        </p>
        <button className="btn-secondary" onClick={handleOpenModal}>Read More</button>
      </div>

      <Modal show={showModal} onClose={handleCloseModal}>
        <h2>About this place</h2>
        <p>
          Welcome to your 360 suite! A luxury furnished 3-bedroom apartment in Abuja that offers the perfect mix of comfort and convenience with uninterrupted power from our solar backup.
        </p>
        <p>
          Unwind in the lounge with a 42" smart TV with DSTV and Netflix and a premium sound system. The fully equipped kitchen, featuring a blender, toaster, and microwave, is perfect for preparing your favorite meals. In the serene bedroom, a 32" smart TV and fresh linens await you for a cozy night's rest.
        </p>

        <h3>The Space</h3>
        <p>
          Modern, self-contained studio in Garki with 24/7 power.
        </p>
        <p>
          Features a cozy lounge with a plasma TV, a well-stocked kitchenette, and a private bathroom. Enjoy high-speed Wi-Fi, free parking, and a smoke alarm system. Just a short walk from Garki Mall. Our suite is a baby-friendly retreat.
        </p>

        <h3>Guest Access</h3>
        <p>
          You'll have private, keyless access to the entire 360 Suite, which includes your own private entrance, parlor, and free on-site parking. The suite is a self-contained unit, so you won't be sharing any space with other guests.
        </p>
        <p>
          You'll also have access to the new stylish parlor. This is the perfect spot for guests to relax and unwind.
        </p>

        <h3>During Your Stay</h3>
        <p>
          We are available to assist you throughout your stay. The best way to reach us is through the Airbnb messaging platform, or you can contact us directly via phone. We aim to respond promptly to all questions or concerns.
        </p>

        <h3>Other Things to Note</h3>
        <h4>Important Notes:</h4>
        <ul>
          <li><strong><i className="fas fa-solar-panel"></i> Power:</strong> Our suite is powered by a solar backup system for 24/7 uninterrupted electricity. You will not be affected by power outages.</li>
          <li><strong><i className="fas fa-shield-alt"></i> Security:</strong> For your safety, the space is equipped with a smoke alarm system.</li>
          <li><strong><i className="fas fa-smoking-ban"></i> House Rules:</strong> This is a non-smoking property. No parties or events are allowed, and we kindly ask you to be mindful of quiet hours after 10 PM.</li>
          <li><strong><i className="fas fa-baby"></i> Baby-Friendly:</strong> The space is suitable for children and babies.</li>
          <li><strong><i className="fas fa-parking"></i> Parking:</strong> Free on-site parking is provided for your convenience.</li>
        </ul>
      </Modal>
    </section>
  );
}

export default About;
